export default __webpack_public_path__ + "static/media/trophy_locked.ae067bdc.webp";